import React from 'react';
import { IoMdClose } from 'react-icons/io';

interface DialogProps {
  title: string;
  children: React.ReactNode;
  onAccept?: () => void;
  onClose?: () => void;
  acceptText?: string;
  closeText?: string;
  showFooter?: boolean;
  error?: boolean;
}

const Dialog = ({
  children,
  title,
  onAccept = undefined,
  onClose = undefined,
  acceptText,
  closeText,
  showFooter = true,
  error = false,
}: DialogProps) => {
  return (
    <div className="dialog-blackout">
      <div className="dialog-container">
        <div className={`dialog-header ${error ? 'error' : ''}`}>
          <span>{title}</span>
          <div className="dialog-header-close" onClick={onClose}>
            <IoMdClose size={25} />
          </div>
        </div>
        <div className="dialog-content">{children}</div>
        {showFooter && (
          <div className="dialog-footer">
            {onAccept && (
              <div className="dialog-footer-cta" onClick={onAccept}>
                {acceptText}
              </div>
            )}
            {onClose && (
              <div className="dialog-footer-cancel" onClick={onClose}>
                {closeText}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dialog;
